import { useEffect, useRef, useState } from 'react';
import { useProfile } from '../hooks/use-public';
import { assetUrl } from '../api/client';

/** 导航栏内 CD 样式背景音乐控件：点击播放旋转，再次点击暂停 */
export default function MusicDisc() {
  const { data: profile } = useProfile();
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  const bgmUrl = profile?.bgmEnabled ? profile?.bgmUrl : null;

  useEffect(() => {
    if (!bgmUrl) {
      audioRef.current?.pause();
      audioRef.current = null;
      setPlaying(false);
      return;
    }
    const audio = new Audio(assetUrl(bgmUrl) ?? bgmUrl);
    audio.loop = true;
    audio.volume = 0.55;
    audio.preload = 'none';
    audioRef.current = audio;
    setPlaying(false);
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, [bgmUrl]);

  if (!bgmUrl) return null;

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (playing) {
      audio.pause();
      setPlaying(false);
    } else {
      audio
        .play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    }
  };

  return (
    <button
      type="button"
      className={`cd-widget ${playing ? 'cd-widget-playing' : ''}`}
      onClick={toggle}
      aria-label={playing ? '停止背景音乐' : '播放背景音乐'}
      title={playing ? '停止背景音乐' : '播放背景音乐'}
    >
      <span className="cd-disc" aria-hidden="true">
        <span className="cd-groove" />
        <span className="cd-label">♪</span>
      </span>
    </button>
  );
}
